import { render, staticRenderFns } from "./award-block-new.vue?vue&type=template&id=0e44e757&scoped=true&lang=pug&"
import script from "./award-block-new.vue?vue&type=script&lang=js&"
export * from "./award-block-new.vue?vue&type=script&lang=js&"
import style0 from "./award-block-new.vue?vue&type=style&index=0&id=0e44e757&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e44e757",
  null
  
)

export default component.exports